import { HeadFC, PageProps } from "gatsby";
import React from "react";
import styled from "styled-components";

import { ContactForm } from "components/ContactForm";
import { PageDivider } from "components/PageDivider";
import { PageHeaderTitle } from "components/PageHeader";
import { getPageMetaFromUrl } from "helpers/meta";
import { APP_GUTTER, APP_WIDTH, BodyText, HeadingText, Section } from "styles";
import Layout from "templates/layout";

const EmailLink = styled.a`
  border-bottom: 1px solid ${({ theme }) => theme.colors.sectionBorder};
`;

const Header = styled(Section)`
  color: ${({ theme }) => theme.colors.white};
`;

const Content = styled(Section)`
  background-color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${APP_WIDTH}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ContactUsPage = ({ location }: PageProps) => {
  return (
    <Layout variant="blue" pathname={location.pathname}>
      <Header className="pb-20 pt-28">
        <PageHeaderTitle>Get in touch</PageHeaderTitle>
        <HeadingText $variant="heading04" className="max-w-4xl">
          Collaboration and partnerships are central to our work. Whether you’re
          a potential investor, hedger or partner we look forward to hearing
          from you.
        </HeadingText>
      </Header>

      <Content className="grid grid-cols-1 gap-20 px-16 pb-20 pt-14 xl:grid-cols-12">
        <PageDivider $isFullWidth className="xl:hidden" />
        <div
          className={`px-6 pt-0 md:pt-8 lg:px-[${APP_GUTTER}px] xl:col-span-5 xl:px-0`}
        >
          <BodyText
            $variant="b2reg"
            $hasPadding={false}
            className="max-w-[490px]"
          >
            Please get in touch with us via the form — alternatively you can
            contact us directly using the following:
          </BodyText>

          <dl className="grid grid-cols-1 gap-y-6 pt-12 md:grid-cols-[110px_1fr]">
            <BodyText $variant="b4impactbold" $hasPadding={false} as="dt">
              Email
            </BodyText>
            <BodyText $variant="b4reg" $hasPadding={false} as="dd">
              <a href="mailto:hello@exponentialmarkets.com">
                hello@exponentialmarkets.com
              </a>
            </BodyText>

            <BodyText $variant="b4impactbold" $hasPadding={false} as="dt">
              Find us
            </BodyText>
            <BodyText $variant="b4reg" $hasPadding={false} as="dd">
              125 Park Avenue, 25th Floor
              <br />
              New York, NY 10017
            </BodyText>

            <BodyText $variant="b4impactbold" $hasPadding={false} as="dt">
              Linkedin
            </BodyText>
            <BodyText $variant="b4reg" $hasPadding={false} as="dd">
              <EmailLink
                href="https://www.linkedin.com/company/exponential-markets"
                target="_blank"
                rel="noreferrer noopener"
              >
                linkedin.com/company/exponential-markets
              </EmailLink>
            </BodyText>
          </dl>
        </div>

        <div
          className={`px-6 lg:px-[${APP_GUTTER}px] order-first xl:order-none xl:col-span-7 xl:px-0`}
        >
          <ContactForm />
        </div>
      </Content>
    </Layout>
  );
};

export default ContactUsPage;

export const Head: HeadFC = () => getPageMetaFromUrl("/contact-us/contact");